import React, { PropsWithChildren, useEffect, useState } from 'react';
import { Provider as ReduxProvider } from 'react-redux';
import { applyMiddleware, compose, createStore } from 'redux';
import thunk from 'redux-thunk';

import { useApp } from '../hooks/useApp';
import { scene } from '../services/scene';
import reducers from '../store/reducers';

const composer = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const makeStore = (loggedIn: boolean, initialState?) => {
  return createStore(
    reducers,
    initialState,
    composer(applyMiddleware(thunk.withExtraArgument({ getScene: () => scene, loggedIn }))),
  );
};

export const ReduxStoreProvider: React.FC<PropsWithChildren> = ({ children }) => {
  const { loggedIn } = useApp();
  const [store, setStore] = useState(() => makeStore(loggedIn));

  useEffect(() => {
    setStore(makeStore(loggedIn));
  }, [loggedIn]);

  return <ReduxProvider store={store}>{children}</ReduxProvider>;
};
